//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import {
  AbstractDepartmentModel,
  AbstractDepartmentNavModel,
} from "@app/catalog-common";

import { 
  debouncedSignal,
  PresenterRegistration, 
  SignalWrapper
} from "@app/shared";

@PresenterRegistration({
  types: [AbstractDepartmentNavModel],
  key: "subMenu",
})
@Component({
  selector: "departments-submenu",
  standalone: false,
  templateUrl: "./departments-submenu.component.html",
   styleUrl: "./departments-submenu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentsSubmenuComponent <TDepartment extends AbstractDepartmentModel> {
  public data: WritableSignal<AbstractDepartmentNavModel<TDepartment>> =
    signal<AbstractDepartmentNavModel<TDepartment>>(null);

  /**
   * @summary Filter for items
   * @description: Creates a debounce signal to ensure reduction of filtering
   */
  public departmentsFilter = SignalWrapper.create({
    coreSignal: signal<string>(null), 
    overrideSignalFn: (coreSignal) => debouncedSignal(coreSignal, 600)
  });
  
  /**
   * @summary Gets departments, if a search is applied, the result is filtered by the criteria   
   */
  public filteredDepartments = computed(() => {
    let departments = this.data()?.items();
    if (!departments) return [];

    let searchValue = this.departmentsFilter.overrideSignal();
    if (!searchValue) return departments; 
    
    return departments.filter(d => 
    {
      if (d.name()?.toLowerCase().includes(searchValue.toLowerCase())) return true;
      if (d.value?.code().toLowerCase().includes(searchValue.toLowerCase())) return true;
      
      return false;
    });
  });    
}
